import { DataTestIds } from '@repo/frontend-shared';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { AvatarButton } from '@repo/ui/components/elements/AvatarButton/AvatarButton';
import { HeaderNotificationsSection } from '@repo/ui/components/HeaderNotificationsSection/HeaderNotificationsSection';
import type { TabType } from '@repo/ui/components/HeaderNotificationsSection/NotificationTabs';

import type { useInAppNotifications } from '../../hooks/use-in-app-notifications';

type InAppNotificationsResult = ReturnType<typeof useInAppNotifications>;

interface AdminHeaderPostNavActionsProps {
  isNotificationsEnabled: boolean;
  notifications: InAppNotificationsResult['notifications'];
  unreadCount: InAppNotificationsResult['unreadCount'];
  tabCounts: InAppNotificationsResult['tabCounts'];
  onTabChange: (tab: TabType) => void;
  onFilterChange: (filter: 'all' | 'unread-only' | 'archived') => void;
  onLoadMore: InAppNotificationsResult['loadMore'];
  hasMore: InAppNotificationsResult['hasMore'];
  onMarkAllAsRead: InAppNotificationsResult['markAllAsRead'];
  onArchiveAll: InAppNotificationsResult['archiveAll'];
  onMarkAsRead: InAppNotificationsResult['markAsRead'];
  onMarkAsUnread: InAppNotificationsResult['markAsUnread'];
  onArchive: InAppNotificationsResult['archive'];
  onUnarchive: InAppNotificationsResult['unarchive'];
  onNotificationsOpen?: () => void;
}

export function AdminHeaderPostNavActions({
  isNotificationsEnabled,
  notifications,
  unreadCount,
  tabCounts,
  onTabChange,
  onFilterChange,
  onLoadMore,
  hasMore,
  onMarkAllAsRead,
  onArchiveAll,
  onMarkAsRead,
  onMarkAsUnread,
  onArchive,
  onUnarchive,
  onNotificationsOpen,
}: AdminHeaderPostNavActionsProps) {
  return (
    <SDSFlexbox alignItems="center" gap="button-medium">
      {isNotificationsEnabled ? (
        <HeaderNotificationsSection
          notifications={notifications}
          unreadCount={unreadCount}
          tabCounts={tabCounts}
          onOpen={onNotificationsOpen}
          onTabChange={onTabChange}
          onFilterChange={onFilterChange}
          onLoadMore={onLoadMore}
          hasMore={hasMore}
          onMarkAllAsRead={onMarkAllAsRead}
          onArchiveAll={onArchiveAll}
          onMarkAsRead={onMarkAsRead}
          onMarkAsUnread={onMarkAsUnread}
          onArchive={onArchive}
          onUnarchive={onUnarchive}
          triggerDataTestId={DataTestIds.COMMON.HEADER_NOTIFICATIONS.TRIGGER}
          dataTestId={DataTestIds.COMMON.HEADER_NOTIFICATIONS.TABS}
          panelDataTestId={DataTestIds.COMMON.HEADER_NOTIFICATIONS.PANEL}
          emptyStateDataTestId={DataTestIds.COMMON.HEADER_NOTIFICATIONS.EMPTY}
          unreadCounterDataTestId={DataTestIds.COMMON.HEADER_NOTIFICATIONS.UNREAD_COUNTER}
          notificationItemDataTestId={DataTestIds.COMMON.HEADER_NOTIFICATIONS.ITEM}
        />
      ) : null}
      <AvatarButton />
    </SDSFlexbox>
  );
}
